var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolPartitionResizer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    title: "navigation-arrow",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "tool-partition-resizer"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 0.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 3.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 6.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 9.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 9.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 12.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 15.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 15.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 21.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 21.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 24.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 27.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 27.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 30.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 33.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 33.5,
    r: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolPartitionResizer);
export default __webpack_public_path__ + "static/media/tool-partition-resizer.f346002d173b4f2c47fdad2ae729a5de.svg";
export { ForwardRef as ReactComponent };